import { ActorType, AuditPolicy, AuthenticationAssuranceLevel, ConcurrencyPolicy, IdempotencyPolicy, PrivacyClassification, ScopeType, } from './operation.js';
import * as OID from './operation-ids.js';
function taxRuleOperation(id, name, accessType, options = {}) {
    const readonly = options.readonly ?? false;
    return {
        id,
        name,
        labelKey: `operations.taxRules.${id.split('.').at(-1)}.label`,
        descriptionKey: `operations.taxRules.${id.split('.').at(-1)}.description`,
        permission: readonly ? 'organization:tax:read' : 'organization:tax:manage',
        permissionId: readonly ? 'organization:tax:read' : 'organization:tax:manage',
        module: 'TAX',
        requiredModules: ['TAX'],
        requiresEntitledModule: true,
        requiredAal: options.aal2 || !readonly
            ? AuthenticationAssuranceLevel.AAL2
            : AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.ORGANIZATION, ScopeType.BRANCH],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH'],
        requestedScope: {
            organizationId: [{ source: 'query', field: 'organizationId' }],
            branchId: [{ source: 'query', field: 'branchId' }],
        },
        allowedPersonas: ['ORG_ADMIN'],
        allowedActorTypes: [ActorType.USER],
        forcesClientScope: false,
        makerCheckerRequired: !readonly,
        idempotencyPolicy: options.idempotent
            ? IdempotencyPolicy.REQUIRED
            : IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: readonly ? ConcurrencyPolicy.NONE : ConcurrencyPolicy.OPTIMISTIC,
        auditPolicy: readonly ? AuditPolicy.READ : AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: id,
        httpMethods: readonly ? ['GET'] : ['POST'],
        isReadOnly: readonly,
        isFinancial: true,
        supportDelegationEligible: readonly,
        delegationPolicy: readonly ? 'READ_ONLY' : 'NOT_ALLOWED',
        accessType,
    };
}
export const TAX_RULE_OPERATIONS = {
    [OID.TAX_RULE_LIST]: taxRuleOperation(OID.TAX_RULE_LIST, 'List tax rules', 'READ', {
        readonly: true,
    }),
    [OID.TAX_RULE_READ]: taxRuleOperation(OID.TAX_RULE_READ, 'Read tax rule', 'READ', {
        readonly: true,
    }),
    [OID.TAX_RULE_CREATE_VERSION]: taxRuleOperation(OID.TAX_RULE_CREATE_VERSION, 'Create tax-rule version', 'ADMIN', { idempotent: true }),
    [OID.TAX_RULE_SUBMIT]: taxRuleOperation(OID.TAX_RULE_SUBMIT, 'Submit tax rule', 'ADMIN', {
        idempotent: true,
    }),
    [OID.TAX_RULE_APPROVE]: taxRuleOperation(OID.TAX_RULE_APPROVE, 'Approve tax rule', 'ADMIN', {
        aal2: true,
        idempotent: true,
    }),
    [OID.TAX_RULE_SUSPEND]: taxRuleOperation(OID.TAX_RULE_SUSPEND, 'Suspend tax rule', 'ADMIN', {
        aal2: true,
        idempotent: true,
    }),
    [OID.TAX_RULE_RETIRE]: taxRuleOperation(OID.TAX_RULE_RETIRE, 'Retire tax rule', 'ADMIN', {
        aal2: true,
        idempotent: true,
    }),
    [OID.TAX_RULE_IMPACT_ANALYZE]: taxRuleOperation(OID.TAX_RULE_IMPACT_ANALYZE, 'Analyze tax-rule impact', 'READ', { readonly: true }),
};
